export const PALETTE_COLOR_TOKEN = "{color}";
export const PALETTE_CLASS_TEMPLATE = `ds-palette--${PALETTE_COLOR_TOKEN}`;
